
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3d2EW", function(module, exports) {
/* EllipsisDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");

/**
 * @generated SignedSource<<969d998219a5203c7fe4a088a6d61867>>
 * @relayHash f3daba5c1d36d154929398d826658f41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be2e854a482c526c0bee63fe1b2baaddf9f7f60f15ff182fbde08a76442d8943
const $024722c0cfe5fb14$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "dynamic",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "representation"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPropertiesQueryWithBodyRepresentationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPropertiesQueryWithBodyRepresentationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f3daba5c1d36d154929398d826658f41",
            "id": "be2e854a482c526c0bee63fe1b2baaddf9f7f60f15ff182fbde08a76442d8943",
            "metadata": {},
            "name": "ContentPropertiesQueryWithBodyRepresentationQuery",
            "operationKind": "query",
            "text": "query ContentPropertiesQueryWithBodyRepresentationQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,type,properties(key:\"editor\"){nodes{id,key,value}},operations{operation,targetType},body{dynamic{representation}},metadata{frontend{fabricEditorSupported}}}}}"
        }
    };
}();
$024722c0cfe5fb14$var$node.hash = "5d011eb8e7550fa243322c900f718bd5";
var $024722c0cfe5fb14$export$2e2bcd8739ae039 = $024722c0cfe5fb14$var$node;


/**
 * @generated SignedSource<<145a3d584450a2c65a7082afbaf306c2>>
 * @relayHash 78f7f047c2eeaba388f789341164eb05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e088eb03f247f33e1a36638ceb73aeb312be09e8d8845193a7a0a0b4ff5c388
const $aa388e064c0879e1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPropertiesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPropertiesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "78f7f047c2eeaba388f789341164eb05",
            "id": "8e088eb03f247f33e1a36638ceb73aeb312be09e8d8845193a7a0a0b4ff5c388",
            "metadata": {},
            "name": "ContentPropertiesQuery",
            "operationKind": "query",
            "text": "query ContentPropertiesQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,type,properties(key:\"editor\"){nodes{id,key,value}},operations{operation,targetType}}}}"
        }
    };
}();
$aa388e064c0879e1$var$node.hash = "3c9ecddff6610855702eca8455e182f9";
var $aa388e064c0879e1$export$2e2bcd8739ae039 = $aa388e064c0879e1$var$node;


const $65e63a8a734d713c$export$4ea7a3f4ac83fe8b = (0, $aa388e064c0879e1$export$2e2bcd8739ae039);
const $65e63a8a734d713c$export$3fec1b8531f6a124 = (0, $024722c0cfe5fb14$export$2e2bcd8739ae039);



var $2kB0r = parcelRequire("2kB0r");

var $4wEOc = parcelRequire("4wEOc");


var $kRW4Y = parcelRequire("kRW4Y");


var $ayQVU = parcelRequire("ayQVU");


var $b66o6 = parcelRequire("b66o6");


var $v1jQ6 = parcelRequire("v1jQ6");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");


var $lJDEI = parcelRequire("lJDEI");


var $7Sm4c = parcelRequire("7Sm4c");


var $k0pnk = parcelRequire("k0pnk");


var $BCkug = parcelRequire("BCkug");


var $5ZqQS = parcelRequire("5ZqQS");


var $1NBp8 = parcelRequire("1NBp8");


var $6fil2 = parcelRequire("6fil2");


var $9BVDK = parcelRequire("9BVDK");


var $dPJCf = parcelRequire("dPJCf");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $l3C2L = parcelRequire("l3C2L");


var $6ld6a = parcelRequire("6ld6a");


var $5SlMo = parcelRequire("5SlMo");


var $d8oE8 = parcelRequire("d8oE8");


var $6DX3n = parcelRequire("6DX3n");


var $iQb1R = parcelRequire("iQb1R");















var $6fjxX = parcelRequire("6fjxX");


var $4cOi8 = parcelRequire("4cOi8");


var $lOeVN = parcelRequire("lOeVN");


var $cEgMD = parcelRequire("cEgMD");

const $d12f14fcd1ce1fef$var$i18n = (0, $h82at.defineMessages)({
    shareFeedback: {
        id: "editor-ellipsis-dropdown.open.ellipsis.hub.share-feedback",
        defaultMessage: "Give feedback on Company hub"
    }
});
function $d12f14fcd1ce1fef$export$6509bc85392c811e({ spaceKey: spaceKey }) {
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const openFeedbackCollector = (0, $lOeVN.useFeedbackCollector)({
        source: 'hubEditorEllipsisDropdown',
        type: (0, $4cOi8.FeedbackType).COMPANY_HUB
    });
    return (0, $42omo.useCallback)((menuItems)=>{
        if (!isCompanyHub) return;
        menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
            hasSeparator: menuItems.length >= 1,
            key: "company-hub-settings-items"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: "share-feedback",
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
                label: ""
            }),
            onClick: openFeedbackCollector
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $d12f14fcd1ce1fef$var$i18n.shareFeedback))));
    }, [
        isCompanyHub,
        openFeedbackCollector
    ]);
}



var $c0rhi = parcelRequire("c0rhi");

function $4550e48693be1fb4$var$_defineProperty(e, r, t) {
    return (r = $4550e48693be1fb4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4550e48693be1fb4$var$_toPropertyKey(t) {
    var i = $4550e48693be1fb4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4550e48693be1fb4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $4550e48693be1fb4$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    preview: {
        id: "editor-ellipsis-dropdown.preview",
        defaultMessage: "Preview"
    },
    templateDocs: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.templates",
        defaultMessage: "Templates"
    },
    importDocs: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.import",
        defaultMessage: "Import"
    },
    addLabels: {
        id: "editor-ellipsis-dropdown.open.ellipsis.edit.labels",
        defaultMessage: "Add labels"
    },
    deleteUnpublishedPage: {
        id: "editor-ellipsis-dropdown.open.ellipsis.page.delete",
        defaultMessage: "Delete unpublished page"
    },
    deleteUnpublishedBlogpost: {
        id: "editor-ellipsis-dropdown.open.ellipsis.blogpost.delete",
        defaultMessage: "Delete unpublished blog post"
    },
    revert: {
        id: "editor-ellipsis-dropdown.open.ellipsis.revert",
        defaultMessage: "Revert to previous version"
    },
    updateWithoutNotifying: {
        id: "editor-ellipsis-dropdown.open.ellipsis.update.without.notify",
        defaultMessage: "Update without notifying watchers"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    openTemplateBrowser: {
        id: "editor-ellipsis-dropdown.open.template.browser",
        defaultMessage: "Open template browser"
    },
    revertEditor: {
        id: "editor-ellipsis-dropdown.open.ellipsis.revert.editor",
        defaultMessage: "Revert to legacy editor"
    },
    undo: {
        id: "editor-ellipsis-dropdown.open.ellipsis.editor.undo",
        defaultMessage: "Undo"
    },
    redo: {
        id: "editor-ellipsis-dropdown.open.ellipsis.editor.redo",
        defaultMessage: "Redo"
    },
    findReplace: {
        id: "editor-ellipsis-dropdown.open.ellipsis.editor.find.replace",
        defaultMessage: "Find and replace"
    }
});
const $4550e48693be1fb4$var$noop = ()=>{}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4550e48693be1fb4$var$MenuItemContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $4550e48693be1fb4$var$previewPage = (createAnalyticsEvent, onPreviewClicked, contentId, contentType)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'previewPage',
            source: 'ellipsisDropdownComponent',
            objectId: contentId,
            objectType: contentType
        }
    }).fire();
    onPreviewClicked(false);
};
const $4550e48693be1fb4$var$publishWithoutNotify = (createAnalyticsEvent, onClickPublish, contentId, contentType)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'publishWithoutNotifyFromOverflow',
            source: 'ellipsisDropdownComponent',
            objectId: contentId,
            objectType: contentType
        }
    }).fire();
    onClickPublish({
        suppressNotifyWatchers: true
    })();
};
class $4550e48693be1fb4$var$EllipsisDropdownClass extends (0, $42omo.PureComponent) {
    componentDidMount() {
        this.setEditorProperty();
    }
    /**
   * Menu items are pushed into the 'items' list which is used to create the '•••' menu
   * (aka more aka ellipsis aka meatball) for editor pages
   */ _getItems(dialogs) {
        const { addCompanyHubSettingsGroupMenuItems: addCompanyHubSettingsGroupMenuItems, contentType: contentType, isDisabled: isDisabled, isUnpublishedDraft: isUnpublishedDraft, showRevertDialog: showRevertDialog, spaceKey: spaceKey, contentId: contentId, isContentCreationPanelShown: isContentCreationPanelShown, contentCreationPanelMode: contentCreationPanelMode, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onClickPublish: onClickPublish, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, onPreviewClicked: onPreviewClicked, createAnalyticsEvent: createAnalyticsEvent, isImportDisabled: isImportDisabled, push: push, switchToLivePage: switchToLivePage, showCommentsPanel: showCommentsPanel, hasEditPermission: hasEditPermission, editorActions: editorActions } = this.props;
        if (this.state.isMenuOpen) createAnalyticsEvent?.({
            type: 'sendScreenEvent',
            data: {
                name: 'ellipsisDropdownForMoreItems'
            }
        }).fire();
         // Don't want to trigger exposures when users open the ellipsis dropdown we are
        // just disabling an item that is not required for the experiment
        // The exposure will happen when the user converts a page instead
        const [onEditConvertExp] = (0, $6mKj3.UNSAFE_noExposureExp)('platform_editor_on_edit_convert');
        const addPreviewMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "preview",
                onClick: ()=>{
                    $4550e48693be1fb4$var$previewPage(createAnalyticsEvent, onPreviewClicked, contentId, contentType);
                },
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                    shortcut: (0, $gnkil.EDITOR2_SHORTCUTS).PREVIEW
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.preview)));
        };
        const showViewChangesDialog = ()=>dialogs.showDialog((0, $l3C2L.ViewChangesDialogLoader), {
                contentId: contentId
            });
        const addViewChangesMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "view-changes",
                onClick: this.saveDraftAnd(showViewChangesDialog)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $6DX3n.i18n).viewChanges)));
        }; // Legacy "Templates and import" combined menu item - only shown when cc_snippets is OFF
        const addTemplateBrowserMenuItem = (menuItems)=>{
            const label = isImportDisabled ? $4550e48693be1fb4$export$a7357cdd1f0b0168.templateDocs : (0, $6DX3n.i18n).templateImportDocs;
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "open-template-browser",
                onClick: ()=>onClickOpenContentCreationPanel?.()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), label)));
        }; // "Templates" menu item - only shown when cc_snippets is ON
        const addTemplatesMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "open-templates",
                onClick: ()=>onClickOpenContentCreationPanel?.((0, $lJDEI.PANEL_MODE_TEMPLATES))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.templateDocs)));
        }; // "Import" menu item - only shown when cc_snippets is ON
        const addImportMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "open-import",
                onClick: ()=>onClickOpenContentCreationPanel?.((0, $lJDEI.PANEL_MODE_IMPORT))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.importDocs)));
        };
        const addClassifyContentMenuItem = (menuItems)=>{
            if (this.props.isClassificationEnabled) menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2kB0r.EllipsisClassificationMenuItem), null));
        };
        const addEditLabelsMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k0pnk.EditLabelDropdownItem), {
                contentId: contentId || '',
                spaceKey: spaceKey,
                dialogs: dialogs
            }));
        };
        const addMovePageMenuItem = (menuItems, movePageContentId, movePageSpaceKey)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $v1jQ6.EditorMovePageButtonLoader), {
                contentId: movePageContentId,
                spaceKey: movePageSpaceKey,
                appearance: "dropdownItem",
                analyticsSource: "EllipsisDropdownComponent",
                key: "move-page-button",
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                isUnpublishedDraft: !!isUnpublishedDraft
            }));
        };
        const addResolvedCommentsMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "resolved-comments",
                onClick: ()=>{
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4550e48693be1fb4$var$MenuItemContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $6DX3n.i18n).resolvedComments), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BVDK.ResolvedInlineCommentsCounterLoader), {
                contentId: contentId
            }))));
        };
        const addDeleteChangesMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "delete-changes",
                onClick: this.saveDraftAnd(showRevertDialog)
            }, isUnpublishedDraft && contentType === 'page' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.deleteUnpublishedPage) : null, isUnpublishedDraft && contentType !== 'page' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.deleteUnpublishedBlogpost) : null, !isUnpublishedDraft ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.revert) : null));
        };
        const addSwitchToLiveEditMenuItem = ({ menuItems: menuItemsArg })=>{
            if (contentType === 'page') {
                const switchToLiveEditWebItem = this.props.webItems?.find((item)=>item.id === 'action-switch-to-live-edit');
                if (!switchToLiveEditWebItem) return;
                menuItemsArg.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                    key: "switch-to-live-edit",
                    onClick: switchToLivePage
                }, switchToLiveEditWebItem.label));
            }
        };
        const addPublishGroupMenuItems = (menuItems)=>{
            const publishGroupItems = [];
            if (this.isAllowed((0, $iQb1R.Buttons).SWITCH_TO_LIVE_EDIT) && contentId) addSwitchToLiveEditMenuItem({
                menuItems: publishGroupItems
            });
            if (!isUnpublishedDraft) this.isAllowed((0, $iQb1R.Buttons).PUBLISH_WITHOUT_NOTIFY) && publishGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "publish-without-notify",
                isDisabled: isDisabled,
                onClick: ()=>{
                    $4550e48693be1fb4$var$publishWithoutNotify(createAnalyticsEvent, onClickPublish, contentId, contentType);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.updateWithoutNotifying)));
            publishGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "publish-group-items",
                key: "publish-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, publishGroupItems)));
            return publishGroupItems.length;
        };
        const addOtherGroupMenuItems = (menuItems)=>{
            const otherGroupItems = [];
            this.isAllowed((0, $iQb1R.Buttons).PREVIEW) && addPreviewMenuItem(otherGroupItems);
            if (!isUnpublishedDraft && this.isAllowed((0, $iQb1R.Buttons).VIEW_CHANGES)) addViewChangesMenuItem(otherGroupItems);
             // Show option to expose the page template menu that pops out from the side
            // When cc_snippets is ON, show separate Templates and Import menu items
            // When cc_snippets is OFF, show combined "Templates and import" menu item
            if (this.isAllowed((0, $iQb1R.Buttons).TEMPLATE_BROWSER)) {
                // We show it for unpublished drafts by default, and for published pages only when
                // `cc_snippets` is enabled.
                const isPageWithTemplateAccess = contentType === 'page' && (isUnpublishedDraft || (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false));
                if ((0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) {
                    // Templates: shows when panel closed OR panel in import mode
                    const shouldShowTemplatesMenuItem = isPageWithTemplateAccess && (!isContentCreationPanelShown || contentCreationPanelMode === (0, $lJDEI.PANEL_MODE_IMPORT)); // Import: shows when panel closed OR panel in templates mode (and import not disabled)
                    const shouldShowImportMenuItem = isPageWithTemplateAccess && !isImportDisabled && (!isContentCreationPanelShown || contentCreationPanelMode === (0, $lJDEI.PANEL_MODE_TEMPLATES));
                    if (shouldShowTemplatesMenuItem) addTemplatesMenuItem(otherGroupItems);
                    if (shouldShowImportMenuItem) addImportMenuItem(otherGroupItems);
                } else {
                    // Legacy "Templates and import" combined menu item - only shown when flag is OFF
                    const shouldShowOpenContentCreationMenuItem = !isContentCreationPanelShown && isPageWithTemplateAccess;
                    if (shouldShowOpenContentCreationMenuItem) addTemplateBrowserMenuItem(otherGroupItems);
                }
            }
            if (contentId && spaceKey) {
                this.isAllowed((0, $iQb1R.Buttons).CLASSIFY_CONTENT) && addClassifyContentMenuItem(otherGroupItems);
                this.isAllowed((0, $iQb1R.Buttons).EDIT_LABELS) && addEditLabelsMenuItem(otherGroupItems);
                this.isAllowed((0, $iQb1R.Buttons).MOVE_PAGE) && addMovePageMenuItem(otherGroupItems, contentId, spaceKey);
                this.isAllowed((0, $iQb1R.Buttons).RESOLVED_COMMENTS) && addResolvedCommentsMenuItem(otherGroupItems);
            } // Empty title needed to maintain blank line above group
            otherGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "other-group-items",
                key: "other-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                hasSeparator: menuItems.length >= 1
            }, otherGroupItems)));
        };
        const addEditorActionsGroupMenuItems = (menuItems)=>{
            const editorActionsGroupItems = [];
            const isAllowed = (contentType === 'page' || contentType === 'blogpost') && hasEditPermission;
            if (!isAllowed || !editorActions) return;
            const { canUndo: editorCanUndo, canRedo: editorCanRedo, undo: editorUndo, redo: editorRedo, activateFindReplace: editorActivateFindReplace } = editorActions;
            if (!!editorUndo) editorActionsGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "editor-undo",
                isDisabled: !editorCanUndo,
                onClick: ()=>{
                    editorUndo?.();
                },
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                    shortcut: (0, $gnkil.EDITOR2_SHORTCUTS).UNDO
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.undo)));
            if (!!editorRedo) editorActionsGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "editor-redo",
                isDisabled: !editorCanRedo,
                onClick: ()=>{
                    editorRedo?.();
                },
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                    shortcut: (0, $gnkil.EDITOR2_SHORTCUTS).REDO
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.redo)));
            if (!!editorActivateFindReplace) editorActionsGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "editor-find-replace",
                onClick: ()=>{
                    editorActivateFindReplace?.();
                },
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                    shortcut: (0, $gnkil.EDITOR2_SHORTCUTS).FIND_REPLACE
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.findReplace)));
            editorActionsGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "editor-actions-group-items",
                key: "editor-actions-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                hasSeparator: menuItems.length >= 1
            }, editorActionsGroupItems)));
        };
        const showRevertEditorDialog = ()=>{
            dialogs.showDialog((0, $b66o6.RevertEditorDialog), {
                contentId: contentId,
                onPageRevert: ()=>(0, $d8oE8.onClickPageRevert)(push, contentType, spaceKey, contentId)
            });
        };
        const addRevertToLegacyEditor = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: "revert-editor",
                onClick: this.saveDraftAnd(showRevertEditorDialog)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.revertEditor)));
        };
        const addDiscardGroupMenuItems = (menuItems)=>{
            const discardGroupItems = [];
            if (this.isAllowed((0, $iQb1R.Buttons).DELETE_DRAFT)) {
                addDeleteChangesMenuItem(discardGroupItems);
                this.state.isPageAutoconverted && ((0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? true : !onEditConvertExp.get('isEnabled', false)) && addRevertToLegacyEditor(discardGroupItems);
            } // Empty title needed to maintain blank line above group
            discardGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "discard-group-items",
                key: "discard-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                hasSeparator: menuItems.length >= 1
            }, discardGroupItems)));
        };
        const allMenuItems = []; /**
                                                 * Menu items are separated into three groups: publish, other and discard
                                                 * Use the allowedEllipsisButtons array to filter for buttons needed to be rendered
                                                 */ 
        addPublishGroupMenuItems(allMenuItems);
        addEditorActionsGroupMenuItems(allMenuItems);
        addOtherGroupMenuItems(allMenuItems);
        addDiscardGroupMenuItems(allMenuItems);
        addCompanyHubSettingsGroupMenuItems(allMenuItems);
        return allMenuItems;
    }
    render() {
        const { isDisabled: isDisabled, tooltipDisabledState: tooltipDisabledState } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $kRW4Y.DialogsStateContainer)
            ]
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "ellipsis-menu"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5SlMo.CommonDropdownMenu), {
                isMenuOpen: this.state.isMenuOpen,
                handleMenuOpenChange: this.handleMenuOpenChange,
                isDisabled: isDisabled,
                tooltipDisabledState: tooltipDisabledState
            }, this._getItems(dialogs))));
    }
    constructor(...args){
        super(...args);
        $4550e48693be1fb4$var$_defineProperty(this, "context", void 0);
        $4550e48693be1fb4$var$_defineProperty(this, "state", {
            isMenuOpen: this.props.isInitialMenuOpen,
            isPageAutoconverted: false
        }); /**
         * Set editor property state
         * @returns {Promise<void>}
         */ 
        $4550e48693be1fb4$var$_defineProperty(this, "setEditorProperty", async ()=>{
            const { contentId: contentId } = this.props;
            const { data: contentPropertiesData } = await (0, $c0rhi.queryInterop)({
                query: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? (0, $65e63a8a734d713c$export$3fec1b8531f6a124) : (0, $65e63a8a734d713c$export$4ea7a3f4ac83fe8b),
                variables: {
                    contentId: contentId
                }
            }).catch((e)=>{
                if ((0, $1uFM6.isUnauthorizedError)(e) || (0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
                else (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    attribution: (0, $3IBnw.Attribution).BACKBONE
                });
                return {
                    data: null
                };
            });
            if (contentPropertiesData) {
                const { editorProperty: editorProperty, isAutoConverted: isAutoConverted } = (0, $ayQVU.getAutoConvertionInfo)(contentPropertiesData?.content?.nodes?.[0]);
                const isNewPage = contentPropertiesData?.content?.nodes?.length === 0;
                this.setState({
                    isPageAutoconverted: ((0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? !!isAutoConverted : !editorProperty) && !isNewPage
                });
            }
        });
        $4550e48693be1fb4$var$_defineProperty(this, "saveDraftAnd", (afterSaveDraftDispatched)=>()=>{
                if (this.props.saveDraft) this.props.saveDraft();
                afterSaveDraftDispatched();
            }); // when allowed ellipsis buttons is undefined, enable all buttons
        $4550e48693be1fb4$var$_defineProperty(this, "isAllowed", (menuItem)=>this.props.allowedEllipsisButtons?.includes(menuItem) ?? true);
        $4550e48693be1fb4$var$_defineProperty(this, "handleMenuOpenChange", (attrs)=>this.setState({
                isMenuOpen: attrs.isOpen
            }));
    }
}
$4550e48693be1fb4$var$_defineProperty($4550e48693be1fb4$var$EllipsisDropdownClass, "displayName", 'EllipsisDropdown');
$4550e48693be1fb4$var$_defineProperty($4550e48693be1fb4$var$EllipsisDropdownClass, "defaultProps", {
    saveDraft: $4550e48693be1fb4$var$noop,
    isDisabled: false,
    isInitialMenuOpen: false
});
const $4550e48693be1fb4$export$82d507aca0e648e3 = (0, $7aRa9.withFlags)((props)=>{
    const addCompanyHubSettingsGroupMenuItems = (0, $d12f14fcd1ce1fef$export$6509bc85392c811e)(props);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isEnabled: isClassificationEnabled } = (0, $4wEOc.useIsDataClassificationEnabledForOrg)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const webItemLocation = (0, $6ld6a.useWebItemLocation)({
        location: 'system.content.action',
        contentId: props.contentId
    });
    const switchToLivePage = (0, $BCkug.useSwitchToLivePage)({
        contentId: props.contentId,
        spaceId: props.spaceId,
        isUnpublishedDraft: !!props.isUnpublishedDraft,
        flags: props.flags,
        retrieveEditorTitleAndContent: props.retrieveEditorTitleAndContent,
        saveDraft: props.saveDraft,
        analyticsSource: 'ellipsisDropdownComponent',
        adfOrigin: 'EDITOR',
        onSuccessfulConversion: ()=>{
            // Redirect to the route for the new live page.
            push((0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: props.spaceKey,
                contentId: props.contentId
            }));
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4550e48693be1fb4$var$EllipsisDropdownClass, {
        ...props,
        addCompanyHubSettingsGroupMenuItems: addCompanyHubSettingsGroupMenuItems,
        createAnalyticsEvent: createAnalyticsEvent,
        isClassificationEnabled: isClassificationEnabled,
        push: push,
        webItems: webItemLocation?.webItems || [],
        switchToLivePage: switchToLivePage,
        showCommentsPanel: showCommentsPanel
    });
});
module.exports["i18n"] = $4550e48693be1fb4$export$a7357cdd1f0b0168;
module.exports["EllipsisDropdownComponent"] = $4550e48693be1fb4$export$82d507aca0e648e3;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("fLkCg"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("dP4Oh"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("6PB7O"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("2oJrI"))).CommentsPanelWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelFilterMenu
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            }
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $9VQUw.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = (0, $9wGTI.fg)('confluence_embed_hide_close_button') && allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo') && (0, $9wGTI.fg)('jira_linked_confluence_doc_rovo_nudge_gate');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType)=>({ setState: setState })=>{
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $9wEpK = parcelRequire("9wEpK");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const baseOptions = {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    };
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network'
    });
    const { data: data, loading: loading, error: error } = queryResult;
    const networkStatus = 'networkStatus' in queryResult && queryResult.networkStatus !== undefined ? queryResult.networkStatus : (0, $9wEpK.NetworkStatus).ready;
    const refetch = 'refetch' in queryResult && typeof queryResult.refetch === 'function' ? queryResult.refetch : $be6154107952d370$var$noOpRefetch;
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<9576c4641d6e53de65b0b62ec71933b2>>
 * @relayHash 5b33d38d543554afec98c6d129862ca0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5b33d38d543554afec98c6d129862ca0",
            "id": "c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\",\"current\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "aad09466db1f47073b1a0249e54dc3a4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("8FCWK"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("8FCWK", function(module, exports) {

let $65005d03f1075b43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65005d03f1075b43$var$load("hhss7"),
    $65005d03f1075b43$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("bSvtO", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $1P1Tu.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $9zUhf.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $9zUhf.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $9zUhf.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;

});

parcelRegister("fLkCg", function(module, exports) {

let $b79b3cc046485688$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b79b3cc046485688$var$load("5vfHd"),
    $b79b3cc046485688$var$load("2Stk7"),
    $b79b3cc046485688$var$load("3roy8"),
    $b79b3cc046485688$var$load("ivbae"),
    $b79b3cc046485688$var$load("3Bbwl"),
    $b79b3cc046485688$var$load("7EorR"),
    $b79b3cc046485688$var$load("9AXkC"),
    $b79b3cc046485688$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("dP4Oh", function(module, exports) {

let $a103c4f1a5d8f8d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a103c4f1a5d8f8d4$var$load("kHOMt"),
    $a103c4f1a5d8f8d4$var$load("9AXkC"),
    $a103c4f1a5d8f8d4$var$load("jYUNl"),
    $a103c4f1a5d8f8d4$var$load("foy8I"),
    $a103c4f1a5d8f8d4$var$load("5vfHd"),
    $a103c4f1a5d8f8d4$var$load("2Stk7"),
    $a103c4f1a5d8f8d4$var$load("6wr18"),
    $a103c4f1a5d8f8d4$var$load("ffEVr"),
    $a103c4f1a5d8f8d4$var$load("gYeBT"),
    $a103c4f1a5d8f8d4$var$load("8LtYa"),
    $a103c4f1a5d8f8d4$var$load("9qN8n"),
    $a103c4f1a5d8f8d4$var$load("g9CVe"),
    $a103c4f1a5d8f8d4$var$load("3JSgG"),
    $a103c4f1a5d8f8d4$var$load("cKm5l"),
    $a103c4f1a5d8f8d4$var$load("3roy8"),
    $a103c4f1a5d8f8d4$var$load("h3ABO"),
    $a103c4f1a5d8f8d4$var$load("kC80R"),
    $a103c4f1a5d8f8d4$var$load("7EorR"),
    $a103c4f1a5d8f8d4$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("6PB7O", function(module, exports) {

let $4f944dbe79d36182$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f944dbe79d36182$var$load("6wr18"),
    $4f944dbe79d36182$var$load("ffEVr"),
    $4f944dbe79d36182$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("2oJrI", function(module, exports) {

let $1bf113457c070934$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1bf113457c070934$var$load("h3ABO"),
    $1bf113457c070934$var$load("3Tca0"),
    $1bf113457c070934$var$load("6wr18"),
    $1bf113457c070934$var$load("d24tW"),
    $1bf113457c070934$var$load("bfveI"),
    $1bf113457c070934$var$load("1GCFv"),
    $1bf113457c070934$var$load("4l6RQ"),
    $1bf113457c070934$var$load("cLmw6"),
    $1bf113457c070934$var$load("lNrIG"),
    $1bf113457c070934$var$load("dvUU0"),
    $1bf113457c070934$var$load("a9w2G"),
    $1bf113457c070934$var$load("gYeBT"),
    $1bf113457c070934$var$load("8LtYa"),
    $1bf113457c070934$var$load("iGCP8"),
    $1bf113457c070934$var$load("lGcru"),
    $1bf113457c070934$var$load("6cnH1"),
    $1bf113457c070934$var$load("lkOIY"),
    $1bf113457c070934$var$load("dI1Cd"),
    $1bf113457c070934$var$load("jbxHq"),
    $1bf113457c070934$var$load("8YSo7"),
    $1bf113457c070934$var$load("e7ZUf"),
    $1bf113457c070934$var$load("gL8bn"),
    $1bf113457c070934$var$load("9ijrN"),
    $1bf113457c070934$var$load("hv4mn"),
    $1bf113457c070934$var$load("Wowvf"),
    $1bf113457c070934$var$load("3JSgG"),
    $1bf113457c070934$var$load("cyGuT"),
    $1bf113457c070934$var$load("ffEVr"),
    $1bf113457c070934$var$load("9AXkC"),
    $1bf113457c070934$var$load("28arV"),
    $1bf113457c070934$var$load("hhss7"),
    $1bf113457c070934$var$load("3yuZ2"),
    $1bf113457c070934$var$load("7K6ua"),
    $1bf113457c070934$var$load("jYUNl"),
    $1bf113457c070934$var$load("foy8I"),
    $1bf113457c070934$var$load("lpuQ4"),
    $1bf113457c070934$var$load("6hFtc"),
    $1bf113457c070934$var$load("f1Pmi"),
    $1bf113457c070934$var$load("dP7ao"),
    $1bf113457c070934$var$load("hogcU"),
    $1bf113457c070934$var$load("frluw"),
    $1bf113457c070934$var$load("5vfHd"),
    $1bf113457c070934$var$load("2Stk7"),
    $1bf113457c070934$var$load("77NEU"),
    $1bf113457c070934$var$load("2uVTT"),
    $1bf113457c070934$var$load("jsvF6"),
    $1bf113457c070934$var$load("4jlMu"),
    $1bf113457c070934$var$load("3roy8"),
    $1bf113457c070934$var$load("hrqeu"),
    $1bf113457c070934$var$load("4FNcq"),
    $1bf113457c070934$var$load("9LW4b"),
    $1bf113457c070934$var$load("fnlWy"),
    $1bf113457c070934$var$load("7EorR"),
    $1bf113457c070934$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("v1jQ6", function(module, exports) {

var $5RlDR = parcelRequire("5RlDR");

const $163bb5cb9a2af796$export$bb4636d2bf564dee = (0, $5RlDR.EditorMovePageButton);
module.exports["EditorMovePageButtonLoader"] = $163bb5cb9a2af796$export$bb4636d2bf564dee;

});

parcelRegister("5RlDR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $4KS7f = parcelRequire("4KS7f");


var $dAYOx = parcelRequire("dAYOx");


var $3gadb = parcelRequire("3gadb");


var $jMyy4 = parcelRequire("jMyy4");


var $kRW4Y = parcelRequire("kRW4Y");


var $b3j2Y = parcelRequire("b3j2Y");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $78wUU = parcelRequire("78wUU");


var $bHd1w = parcelRequire("bHd1w");


var $fcURH = parcelRequire("fcURH");


var $ipDsV = parcelRequire("ipDsV");

const $34016fb8fb167321$var$EditorMovePageButtonComponentWithDialogs = ({ spaceKey: spaceKey, contentId: contentId, appearance: appearance = 'dropdownItem', analyticsSource: analyticsSource, dialogs: dialogs, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isUnpublishedDraft: isUnpublishedDraft })=>{
    const intl = (0, $1cfRh.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $ipDsV.default), {
        variables: {
            contentId: contentId
        }
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    if (loading) return null;
    const content = data?.content?.nodes?.[0];
    const contentType = content?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const canMoveContent = isUnpublishedDraft || contentType === 'page' || !!operations.find((op)=>op?.targetType === contentType && op?.operation === 'delete');
    const openMoveModal = ()=>{
        if (contentType === 'page') {
            experienceTracker.start({
                name: (0, $irVI7.MOVE_PAGE_DIALOG_LOAD_EXPERIENCE)
            });
            dialogs.showModal((0, $bHd1w.MovePageDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                isUnpublishedDraft: isUnpublishedDraft,
                isMovingDraftVersion: true,
                referrer: 'editor-move-page-button'
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'openEditorMovePageDialog',
                    source: analyticsSource,
                    objectId: contentId,
                    objectType: 'page'
                }
            }).fire();
        } else if (contentType === 'blogpost') {
            dialogs.showModal((0, $78wUU.MoveBlogModalLoader), {
                currentSpaceKey: spaceKey,
                blogPostId: contentId,
                isEditMode: true,
                isUnpublishedDraft: isUnpublishedDraft,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                referrer: 'editor-move-page-button'
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'openEditorMovePageDialog',
                    source: analyticsSource,
                    objectId: contentId,
                    objectType: 'blog'
                }
            }).fire();
        }
    };
    let component;
    // if FF is on we should show move button for both blog and page types and for both publish and unpublish states
    if (canMoveContent || isUnpublishedDraft && contentType === 'page') {
        if (appearance === 'iconButton') {
            const icon = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                className: "icon aui-icon aui-icon-small aui-iconfont-nav-children"
            });
            component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                tag: "span",
                content: intl.formatMessage((0, $fcURH.i18n).movePageBtnDesc)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                testId: "move-page-icon-button",
                iconBefore: icon,
                appearance: "subtle",
                onClick: openMoveModal
            }));
        } else if (appearance === 'dropdownItem') component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: openMoveModal,
            testId: "move-page-dropdown-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $fcURH.i18n).movePageBtnDesc));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "move-page-button"
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), component);
};
const $34016fb8fb167321$export$65b66e3b59bd4f0 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34016fb8fb167321$var$EditorMovePageButtonComponentWithDialogs, {
            ...props,
            dialogs: dialogs
        }));
};
module.exports["EditorMovePageButton"] = $34016fb8fb167321$export$65b66e3b59bd4f0;

});

parcelRegister("fcURH", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $0ac47e05aff110d2$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    movePageBtnDesc: {
        id: "editor-move-page-button.move.page.description",
        defaultMessage: "Move"
    }
});
module.exports["i18n"] = $0ac47e05aff110d2$export$a7357cdd1f0b0168;

});

parcelRegister("ipDsV", function(module, exports) {
/**
 * @generated SignedSource<<8b348ec545ddb84ebb00613cd13354c7>>
 * @relayHash 630bda5978f017d66aa616a0a7b2cc3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ef4a123bf1a5e07531ecec30a4e8e27da71983f3aded136721f84e25ec4c7f56
const $bf3fab69eab8d3a4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorMovePageButtonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorMovePageButtonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "630bda5978f017d66aa616a0a7b2cc3d",
            "id": "ef4a123bf1a5e07531ecec30a4e8e27da71983f3aded136721f84e25ec4c7f56",
            "metadata": {},
            "name": "EditorMovePageButtonQuery",
            "operationKind": "query",
            "text": "query EditorMovePageButtonQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,type,status,operations{operation,targetType}}}}"
        }
    };
}();
$bf3fab69eab8d3a4$var$node.hash = "54029c77ef9a7e56f195b24f87d3c3ed";
var $bf3fab69eab8d3a4$export$2e2bcd8739ae039 = $bf3fab69eab8d3a4$var$node;
module.exports["default"] = $bf3fab69eab8d3a4$export$2e2bcd8739ae039;

});

parcelRegister("k0pnk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dAYOx = parcelRequire("dAYOx");


var $ho4zm = parcelRequire("ho4zm");


var $9wGTI = parcelRequire("9wGTI");


var $88KVZ = parcelRequire("88KVZ");


var $4vaoM = parcelRequire("4vaoM");

const $bb6d2606da8fa2b2$export$207a057b55bce66d = ({ contentId: contentId, spaceKey: spaceKey, dialogs: dialogs })=>{
    const buttonText = (0, $88KVZ.useLabelsDescriptionText)({
        contentId: contentId
    });
    const showEditLabelDialog = ()=>{
        const dialogProps = {
            contentId: contentId,
            spaceKey: spaceKey,
            source: 'fabricEditor'
        };
        dialogs.showModal((0, $4vaoM.EditLabelDialogLoader), dialogProps);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: "edit-labels",
        onClick: showEditLabelDialog
    }, (0, $9wGTI.fg)('confluence_fronend_labels_categorization_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ho4zm.default), {
        text: buttonText,
        color: "standard"
    }) : buttonText);
};
module.exports["EditLabelDropdownItem"] = $bb6d2606da8fa2b2$export$207a057b55bce66d;

});

parcelRegister("88KVZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $c0rhi = parcelRequire("c0rhi");


var $eDV4X = parcelRequire("eDV4X");


var $cUIkM = parcelRequire("cUIkM");

const $e7b359a64ad828f1$var$i18n = (0, $h82at.defineMessages)({
    edit: {
        id: "labels.modal.title.edit-label",
        defaultMessage: "Edit labels"
    },
    add: {
        id: "labels.modal.title.add-label",
        defaultMessage: "Add labels"
    }
});
const $e7b359a64ad828f1$export$45bed9d3e3f6648d = ({ contentId: contentId, contentType: contentType, labels: labels })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const [hasLabels, setHasLabels] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        async function checkHasLabels() {
            if (contentType === (0, $eDV4X.ContentTypes).TEMPLATE) {
                const labelCount = labels?.length || 0;
                setHasLabels(labelCount > 0);
            } else {
                const { data: data } = await (0, $c0rhi.queryInterop)({
                    query: (0, $cUIkM.LabelsCountQuery),
                    variables: {
                        contentId: contentId,
                        status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
                    }
                });
                setHasLabels((data?.singleContent?.labels?.count ?? 0) > 0);
            }
        }
        checkHasLabels();
    }, [
        contentId,
        contentType,
        labels
    ]);
    return typeof hasLabels === 'boolean' ? formatMessage(hasLabels ? $e7b359a64ad828f1$var$i18n.edit : $e7b359a64ad828f1$var$i18n.add) : '';
};
module.exports["useLabelsDescriptionText"] = $e7b359a64ad828f1$export$45bed9d3e3f6648d;

});

parcelRegister("eDV4X", function(module, exports) {
const $e24dc53dc88ae3e8$export$3211963609921415 = [
    'current',
    'draft'
];
const $e24dc53dc88ae3e8$export$d7a13677648fb230 = 'edit-label-dialog-heading';
var $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CLEAR"] = "clear";
    ActionTypes["CREATE_OPTION"] = "create-option";
    ActionTypes["REMOVE_VALUE"] = "remove-value";
    ActionTypes["POP_VALUE"] = "pop-value";
    ActionTypes["SELECT_OPTION"] = "select-option";
    return ActionTypes;
}({});
const $e24dc53dc88ae3e8$export$cac90560d1a4fb86 = /[:;,.•?&[\]()#^*@!<>]/;
var $e24dc53dc88ae3e8$export$b9e669a853ca2f38 = /*#__PURE__*/ function(ContentTypes) {
    ContentTypes["TEMPLATE"] = "template";
    return ContentTypes;
}({});
module.exports["ALLOWED_CONTENT_STATUSES"] = $e24dc53dc88ae3e8$export$3211963609921415;
module.exports["ActionTypes"] = $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4;
module.exports["INVALID_CHARACTERS"] = $e24dc53dc88ae3e8$export$cac90560d1a4fb86;
module.exports["ContentTypes"] = $e24dc53dc88ae3e8$export$b9e669a853ca2f38;

});

parcelRegister("cUIkM", function(module, exports) {

var $l2332 = parcelRequire("l2332");

const $865b819f05ce8472$export$83f92c0e89c7ef19 = (0, $l2332.default);
module.exports["LabelsCountQuery"] = $865b819f05ce8472$export$83f92c0e89c7ef19;

});

parcelRegister("l2332", function(module, exports) {
/**
 * @generated SignedSource<<77e4b0b58e28aa9e5d53040a80f638de>>
 * @relayHash 40dd05e6e4e493aa3b103cfde9170502
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3647f89a29157a20ed546e887d1178737c153b5f85382490e77e17398959a935
const $d1cf4abf26c9ada3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "orderBy",
                            "value": {
                                "direction": "ASCENDING",
                                "sortField": "LABELLING_CREATIONDATE"
                            }
                        }
                    ],
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "count"
                        }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LabelCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LabelCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "40dd05e6e4e493aa3b103cfde9170502",
            "id": "3647f89a29157a20ed546e887d1178737c153b5f85382490e77e17398959a935",
            "metadata": {},
            "name": "LabelCountQuery",
            "operationKind": "query",
            "text": "query LabelCountQuery($contentId:ID!,$status:[String]){singleContent(id:$contentId,status:$status){id,labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count}}}"
        }
    };
}();
$d1cf4abf26c9ada3$var$node.hash = "6b067ef7961ef1c9ac299658885db49d";
var $d1cf4abf26c9ada3$export$2e2bcd8739ae039 = $d1cf4abf26c9ada3$var$node;
module.exports["default"] = $d1cf4abf26c9ada3$export$2e2bcd8739ae039;

});

parcelRegister("4vaoM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a85e440150ad6165$export$761f49b4caa7a581 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "JXn3W",
    name: "EditLabelDialogLoader",
    loader: async ()=>(await (parcelRequire("9XpFj"))).EditLabelDialogComponent
});
module.exports["EditLabelDialogLoader"] = $a85e440150ad6165$export$761f49b4caa7a581;

});

parcelRegister("9XpFj", function(module, exports) {

let $73fd88545a15efec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $73fd88545a15efec$var$load("43bid"),
    $73fd88545a15efec$var$load("loqJg"),
    $73fd88545a15efec$var$load("7EorR"),
    $73fd88545a15efec$var$load("jigcs"),
    $73fd88545a15efec$var$load("1fnbu")
]).then(()=>parcelRequire('m0wkE'));

});

parcelRegister("6ld6a", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $jtuBN = parcelRequire("jtuBN");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipQuery || $[9] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery
        };
        $[8] = skipQuery;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), baseQueryOptions);
    if (!data) {
        let t8;
        let t9;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[11] = t8;
            $[12] = t9;
        } else {
            t8 = $[11];
            t9 = $[12];
        }
        let t10;
        if ($[13] !== error || $[14] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[13] = error;
            $[14] = loading;
            $[15] = t10;
        } else t10 = $[15];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[16] !== allowedWebItems || $[17] !== data || $[18] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        $[16] = allowedWebItems;
        $[17] = data;
        $[18] = notAllowedWebItems;
        $[19] = webItems;
        $[20] = webSections;
    } else {
        webItems = $[19];
        webSections = $[20];
    }
    let t8;
    if ($[21] !== error || $[22] !== webItems || $[23] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[21] = error;
        $[22] = webItems;
        $[23] = webSections;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("kxhju", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iEfsZ = parcelRequire("iEfsZ");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("5SlMo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");


var $9VJDA = parcelRequire("9VJDA");


var $3gadb = parcelRequire("3gadb");

const $79e94f3a61d46da4$var$i18n = (0, $h82at.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    moreActions: {
        id: "editor-ellipsis-dropdown.open.ellipsis.more.actions.tooltip",
        defaultMessage: "More actions"
    }
});
const $79e94f3a61d46da4$export$6885a1ceb54a0bf4 = ({ isMenuOpen: isMenuOpen, handleMenuOpenChange: handleMenuOpenChange, children: children, testId: testId = 'ellipsis-dropdown-menu', isDisabled: isDisabled, tooltipDisabledState: tooltipDisabledState })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const disabledTooltipI18nObject = {
        id: tooltipDisabledState
    };
    const disabledTooltipText = tooltipDisabledState ? formatMessage(disabledTooltipI18nObject) : '';
    const tooltip = isDisabled ? disabledTooltipText : formatMessage($79e94f3a61d46da4$var$i18n.moreActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: isMenuOpen ? '' : tooltip,
        position: "bottom",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "ellipsis-dropdown-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        placement: "bottom-end",
        testId: testId,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                label: formatMessage($79e94f3a61d46da4$var$i18n.moreActions),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                isDisabled: isDisabled,
                appearance: "subtle",
                "aria-expanded": isMenuOpen ? 'true' : 'false'
            }),
        appearance: "tall",
        isOpen: isMenuOpen,
        onOpenChange: handleMenuOpenChange
    }, children)));
};
module.exports["CommonDropdownMenu"] = $79e94f3a61d46da4$export$6885a1ceb54a0bf4;

});

parcelRegister("6DX3n", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $a4d3843be7f7fab1$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    viewChanges: {
        id: "editor-ellipsis-dropdown.open.ellipsis.view.changes",
        defaultMessage: "View changes"
    },
    resolvedComments: {
        id: "editor-ellipsis-dropdown.open.ellipsis.resolved.comments",
        defaultMessage: "Resolved comments"
    },
    templateImportDocs: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.templates.and.import",
        defaultMessage: "Templates & import doc"
    },
    more: {
        id: "editor-ellipsis-dropdown.open.ellipsis.more",
        defaultMessage: "More"
    }
});
module.exports["i18n"] = $a4d3843be7f7fab1$export$a7357cdd1f0b0168;

});


//# sourceMappingURL=EllipsisDropdown.1a31a428.js.map
